import { connect } from 'react-redux';

import { registration } from '@audioplay/web-lib';

export type Props = registration.Props.Register;

export const RegisterBase = registration.Register;

export const Register = connect((state: any) => ({}), {})(RegisterBase);